import Router from './routes'

import ThemeConfig from './theme'
import GlobalStyles from './theme/globalStyles'

import ScrollToTop from './components/ScrollToTop'
import NotistackProvider from './components/NotistackProvider'
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart'
import { Toaster } from 'src/components/Toaster'

export default function App() {
  return (
    <ThemeConfig>
      <NotistackProvider>
        <ScrollToTop />
        <GlobalStyles />
        <BaseOptionChartStyle />
        <Router />
        <Toaster />
      </NotistackProvider>
    </ThemeConfig>
  )
}
